import styled from "styled-components";
import { archetypeColorIndexes } from "../types/IRolesPlayedUtils";
// UI Section
export const EyeIconWrapper = styled.div<{ isActive: boolean }>`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background-color: ${({ isActive }) => (isActive ? "#00A1E4" : "white")};
  border: 1px solid ${({ isActive }) => (isActive ? "#00A1E4" : "#DADADA")};
  cursor: pointer;
  margin-bottom: -6px;
  img {
    width: 20px;
    height: 20px;
    filter: ${({ isActive }) => (isActive ? "brightness(0) invert(1)" : "none")};
  }
`;

export const ArchetypeSidebar = styled.div<{ isSingleArchetype: boolean }>`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  width: 25%;
  gap: 8px;
  justify-content: ${({ isSingleArchetype }) => (isSingleArchetype ? "center" : "flex-start")};
`;

export const ArchetypeItem = styled.div<{ 
  heightPercentage: number; 
  colorIndex: number; 
  isSingleArchetype: boolean;
  isFirst?: boolean;
  isLast?: boolean;
}>`
  display: flex;
  flex-direction:column;
  align-items: ${({ isSingleArchetype }) => (isSingleArchetype ? "center" : "flex-start")};
  // gap: 12px;
  gap: 4px;
  height: ${({ heightPercentage }) => `${heightPercentage}%`};
  min-height: 80px;
  transition: height 0.3s ease;
  border-right: 8px solid ${({ colorIndex }) => archetypeColorIndexes[colorIndex]};
  border-radius: 20px;
  padding: 16px;
  ${props => props.isFirst && `
    border-bottom: 1px solid #DADADA;
  `}
  ${props => props.isLast && `
    border-top: 1px solid #DADADA;
  `}
`;

export const ConnectionContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const ConnectionSVG = styled.svg`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
`;

export const HeaderContent = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.playerDataBorder};
  & .content-text {
    color: ${({ theme }) => theme.playerColor};
    font-family: "Aeonik";
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 40px;
  }
  & .result-buttons {
    display: inline-flex;
    height: 40px;
    align-items: center;
    gap: 16px;
    flex-shrink: 0;
  }
  & .this-season {
    color: ${({ theme }) => theme.playerColor};
    font-feature-settings: "clig" off, "liga" off;
    font-family: "Aeonik";
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24.605px;
  }
  & .result-date {
    color: ${({ theme }) => theme.NumberColor};
    text-align: right;
    font-feature-settings: "clig" off, "liga" off;
    font-family: "DM Mono";
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
    text-transform: uppercase;
  }
`;